import { create } from 'zustand';
import { today } from './clock';

// The site the pipeline bakes by default; streets.json names the one it actually baked.
export const SITE = { lat: 47.2607, lon: 11.3947, timeZone: 'Europe/Vienna' };

export type NeighbourSource = 'loading' | 'osm' | 'placeholder';

export interface Placement {
  groundY: number;
  yaw: number;
  height: number;
  radius: number;
}

interface WorldState {
  date: string;
  // local minutes after midnight; follows the scroll until the visitor moves the slider
  minutes: number;
  follow: boolean;
  origin: { lat: number; lon: number };
  source: NeighbourSource;
  // world y of the hero's ground floor, and the site's turn so its north meets the model's
  groundY: number;
  yaw: number;
  // roof height above the ground, for the shadow readout
  height: number;
  // half the footprint's diagonal, what the shadow camera and the placeholder blocks keep clear of
  radius: number;
  // degrees clockwise from screen up to true north
  compass: number;
  setDate: (date: string) => void;
  setMinutes: (minutes: number, follow: boolean) => void;
  setPlacement: (p: Placement) => void;
  setNeighbours: (source: NeighbourSource, origin: { lat: number; lon: number } | null) => void;
  setCompass: (deg: number) => void;
}

export const useWorldStore = create<WorldState>((set) => ({
  date: today(SITE.timeZone),
  minutes: 15 * 60,
  follow: true,
  origin: { lat: SITE.lat, lon: SITE.lon },
  source: 'loading',
  groundY: 0,
  yaw: 0,
  height: 0,
  radius: 0,
  compass: 0,
  setDate: (date) => set({ date }),
  setMinutes: (minutes, follow) =>
    set((s) => (s.minutes === minutes && s.follow === follow ? s : { minutes, follow })),
  setPlacement: (p) =>
    set((s) =>
      s.groundY === p.groundY && s.yaw === p.yaw && s.height === p.height && s.radius === p.radius
        ? s
        : p,
    ),
  setNeighbours: (source, origin) => set((s) => ({ source, origin: origin ?? s.origin })),
  setCompass: (compass) => set((s) => (Math.abs(s.compass - compass) < 0.5 ? s : { compass })),
}));
